<template>
    <section class="point-show-header">
        <div class="container">
            <div class="header-sec">
                <div class="header-nav">
                    <div class="back-arrow">
                        <a @click="$router.back()" title="Go Back" role="button" href="javascript:void(0)"> <img loading="lazy" src="@/assets/images/back-arrow.webp" alt="back-arrow"></a>
                    </div>
                    <div class="header-logo">
                        <div class="list-con">
                            <h4 class="text-light">WALLET HISTORY</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section>
        <DepositRequestRejected v-if="this.$route.params.type == 'REJECTED'" :walletDetails="walletDetails" />
        <DepositRequestApproved v-if="this.$route.params.type == 'APPROVED'" :walletDetails="walletDetails" />
        <TransactionDetail :walletDetails="walletDetails" />
    </section>

    <section class="withdraw-fix">
        <div class="container">
            <div class="withdraw-fix-sec continue-btn">
                <a @click="$router.push('/')" class="thm-but "> <span class="Back-home"><img
                            src="@/assets/images/back-arrow.webp" alt="back-arrow"></span>
                    Back to home</a>
            </div>
        </div>
    </section>
</template>

<script>
import DepositRequestApproved from '../components/DepositRequestApproved.vue';
import DepositRequestRejected from '../components/DepositRequestRejected.vue';
import TransactionDetail from '../components/TransactionDetail.vue';
import { getWalletDetails } from '../utils/shared-data';
import { defineAsyncComponent } from 'vue';
export default {
    name: "WalletHistoryDetail",
    components:{
        DepositRequestRejected,
        TransactionDetail,
        DepositRequestApproved,
        
    },
    data() {
        return {
            walletDetails: getWalletDetails()
        }
    },
}
</script>